import api from '@/libs/axios'

export default {
  async create(payload) {
    const response = await api.post('/admin/pronun-topics', payload)
    return response.data.data.new_document || null
  },
  async getList(params) {
    let response = await api.get('/admin/pronun-topics', {
      params,
    })
    return response.data.data || null
  },
  async getAll(params) {
    let response = await api.get('/admin/pronun-topics', {
      params,
    })
    return response.data.data || null
  },
  async get(params) {
    let response = await api.get('/admin/pronun-topics/detail', {
      params,
    })
    return response.data.data || null
  },
  async update(payload) {
    let response = await api.put('/admin/pronun-topics', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/pronun-topics', {
      data: payload,
    })
    return response
  },

}
